import { render, staticRenderFns } from "./BaseInfoModal.vue?vue&type=template&id=90f2dd90"
import script from "./BaseInfoModal.vue?vue&type=script&lang=js"
export * from "./BaseInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports